import classNames from 'classnames';
import React from 'react';
import SVGIcon from '../components/SVGIcon';
import topicIcon from '../icons/prefilled/topic.svg';
import styles from './TopicIcon.module.scss';

interface TopicIconProps {
  bordered?: boolean;
}

const TopicIcon = ({ bordered }: TopicIconProps) => (
  <div
    className={classNames(styles.container, { [styles.bordered]: bordered })}
  >
    <SVGIcon>{topicIcon}</SVGIcon>
  </div>
);

export default TopicIcon;
